import Swiper from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { EffectCoverflow, Keyboard, Navigation, Pagination } from "swiper/modules";
export function initClientStatisticSlider(id, direction) {
    if (direction === void 0) { direction = 'horizontal'; }
    var swiperDirection = direction;
    var swiper = new Swiper('#' + id, {
        modules: [Navigation, Pagination, EffectCoverflow, Keyboard],
        centeredSlides: true,
        initialSlide: 0,
        direction: swiperDirection,
        pagination: {
            el: ".swiper-pagination.statistic-component-pagination",
            clickable: true,
        },
        autoHeight: false,
        loop: false,
        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },
    });
}
